import { render, staticRenderFns } from "./ProgramsProgression.vue?vue&type=template&id=3f05f70c&"
import script from "./ProgramsProgression.vue?vue&type=script&lang=js&"
export * from "./ProgramsProgression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports